import { consola, type ConsolaInstance } from 'consola'
import { createSharedComposable } from '#imports'

export const useLogger = createSharedComposable((): ConsolaInstance => {
    return consola
})
